import { useParams } from "react-router-dom";

import { ChangePasswordForm } from "../../components/settings/changePasswordForm";

export default function ChangePassword() {
    const { forgotKey } = useParams<{ forgotKey: string }>();
    return <ChangePasswordForm forgotKey={forgotKey} />;
}
